var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$route.fullPath,staticClass:"Overlay__Wrapper"},[_vm._t("default"),_c('div',{staticClass:"Overlay",class:{ 'Overlay--visible': _vm.isOverlayVisible }},[_c('div',{staticClass:"Overlay__ClickBlokker",on:{"click":_vm.handleClick}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }